import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  clearReelVideoStatus,
  clearSelectedReelVideo,
  getOneReelVideo,
  updateReelVideo,
} from 'slice/reelVideoSlice';
import ReelVideoForm from './ReelVideoForm';

const getErrorMessage = (error) =>
  error?.response?.data?.message || error?.data?.message || error?.message || 'Unable to load reel video.';

const Update = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, selectedItem, lastAction } = useSelector((state) => state.reelVideo);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    dispatch(clearReelVideoStatus());
    dispatch(getOneReelVideo(id));
    setHasSubmitted(false);

    return () => {
      dispatch(clearSelectedReelVideo());
      dispatch(clearReelVideoStatus());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (hasSubmitted && lastAction === 'update' && !loading && !error) {
      toast('Reel video updated successfully!');
      dispatch(clearReelVideoStatus());
      setHasSubmitted(false);
      navigate('/reel-video');
    }
  }, [dispatch, error, hasSubmitted, lastAction, loading, navigate]);

  const handleSubmit = (payload) => {
    setHasSubmitted(true);
    dispatch(updateReelVideo({ id, data: payload }));
  };

  const isCurrentItemLoaded = String(selectedItem?.id || '') === String(id);

  return (
    <>
      <div className="container card my-5">
        {!isCurrentItemLoaded && loading && <p className="mx-3 mt-4">Loading reel video details...</p>}

        {!isCurrentItemLoaded && !loading && error && <p className="mx-3 mt-4 text-danger">{getErrorMessage(error)}</p>}

        {isCurrentItemLoaded && (
          <ReelVideoForm
            mode="update"
            initialValues={selectedItem}
            loading={loading}
            onSubmit={handleSubmit}
            submitLabel="Update Reel Video"
            rowClassName="row p-3"
            labelClassName=""
            buttonWrapperClassName="mt-3 text-right"
            buttonClassName="btn btn-success"
          />
        )}
      </div>
    </>
  );
};

export default Update;
